import { render, staticRenderFns } from "./CommunicationTemplateDeleteModal.vue?vue&type=template&id=30f45ab3&"
import script from "./CommunicationTemplateDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./CommunicationTemplateDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports